<ym-drawer *ngIf="showDrawer" (onClose)="toggleDrawer()" [backdropDismiss]="false">
    <ng-container header>Customize contact view</ng-container>
    <ng-container body>
        <div class="main-content ym-display-flex ym-flex-direction-column ym-h-full ym-gap-5">
            <!-- <ym-alert class="ym-sticky ym-top-n6 ym-z-index-1 ym-mx-n6 ym-mt-n6" [merged]="true" [type]="alertTypes.DANGER" [dismissable]="false" *ngIf="isRequiredError">
                <ng-container description>One of the fields should be required: <b>{{requiredFields}}</b></ng-container>
            </ym-alert> -->
            <div class="fields-main-container" cdkDropList (cdkDropListDropped)="drop($event)">
                <ng-container *ngFor="let field of disaplayEntityViewFields">
                    <div cdkDrag
                        class="field-container ym-bg-white ym-pr-5 ym-mx-n6 ym-hover-bg-gray-10 ym-display-flex ym-gap-3 ym-align-items-flex-start">
                        <span cdkDragHandle
                            class="drag icon ym-svg-md ym-text-secondary ym-cursor-grab ym-mt-2 ym-py-5 ym-pl-4">
                            <ym-icon [iconName]="iconNames.GRIP_VERTICAL"></ym-icon>
                        </span>
                        <span class="info ym-w-full ym-display-flex ym-flex-direction-column ym-py-3">
                            <span class="text ym-font-lg">{{field.label}}</span>
                            <span class="sub-text text ym-font-sm ym-text-secondary">{{field.field_type |
                                textCase}}</span>
                        </span>
                        <span class="action ym-mt-2 ym-py-1 ym-display-flex ym-gap-3">
                            <ym-button [variant]="buttonVariants.ICON_ONLY" [disabled]="!field.is_editable"
                                [icon]="iconNames.DELETE" [tooltip]="'Remove'"
                                (onClick)="removeField(field)"></ym-button>
                        </span>
                    </div>
                </ng-container>
            </div>
            <app-field-selection-dropdown [allFields]="allFields" [allGroups]="allGroups" [value]="entityViewFields"
                (valueChange)="updateEntityViewFields($event)" class="ym-mx-auto ym-pb-6"></app-field-selection-dropdown>
        </div>
    </ng-container>

    <ng-container actions>
        <ym-button [type]="buttonTypes.PRIMARY" [loading]="isLoading" (onClick)="saveEntityAddForm()">
            Save
        </ym-button>
    </ng-container>
</ym-drawer>